import * as React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { nanoid } from "nanoid";
import { kebabCase } from "lodash";

const Summary = ({ summary, category = false, image = false, alt = "" }) => {
  return (
    <div className="content">
      <div className="summary">
        <div className="border">
          <div className="columns no-padding no-margin">
            {image ? (
              <>
                <div className="is-parent column is-10" key={nanoid()}>
                  <h5 className="mt-c mb-c">Summary:</h5>
                  <p className="mt-c">{summary}</p>
                  {category ? (
                    <p>
                      Category:{" "}
                      <Link to={`/category/${kebabCase(category)}/`}>
                        {category}
                      </Link>
                    </p>
                  ) : null}
                </div>
                <div
                  className="is-parent column is-2 is-hidden-mobile"
                  key={nanoid()}
                >
                  <img
                    src={image}
                    alt={alt}
                    placeholder="blurred"
                    layout="fixed"
                    style={{ maxHeight: "130px" }}
                    className="float-right summary-image"
                  />
                </div>
              </>
            ) : (
              <>
                <div className="is-parent column is-12" key={nanoid()}>
                  <h5 className="mt-c mb-c">Summary:</h5>
                  <p className="mt-c">{summary}</p>
                  {category ? (
                    <p>
                      Category:{" "}
                      <Link to={`/category/${kebabCase(category)}/`}>
                        {category}
                      </Link>
                    </p>
                  ) : null}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

Summary.propTypes = {
  url: PropTypes.string,
};

export default Summary;
